export default __webpack_public_path__ + "static/media/1074.9bc4ffcb.png";